// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { TypographyPresentationProps } from "@insite/mobius/Typography";
import { productAttributesStyles } from "@west/Overrides/Components/ProductAttributes";
import { xScreen } from "@west/XDL/Utilities";
import { css } from "styled-components";

const mediumTextStyles: TypographyPresentationProps = {
    size: 14,
    weight: 400,
    color: "text",
    lineHeight: "22px",
}

productAttributesStyles.container = {
    gap: 0,
    offsetCss: css`
        margin: 0;
    `,
};

productAttributesStyles.smallHeadingAndTextStyle = {
    heading: {
        ...mediumTextStyles,
        css: css`
            text-wrap: nowrap;
            text-transform: capitalize;
            &:after {
                content: ":";
            }
        `,
    },
    text: { ...mediumTextStyles },
    wrapper: {
        css: css`
            flex-direction: row;
            gap: 4px;
            ${xScreen("lte", "xs")} {
                flex-wrap: wrap;
            }
        `,
    },
};
